<app-static-pages-header [title]="'Impressum'"></app-static-pages-header>
<div class="container imprint">
  <div class="row justify-content-md-center">
    <div class="col-md-8">
      <h2 class="main__title">Impressum</h2>
      <p>Impressum und Offenlegung gem. § 24 bzw. § 25 MedienG sowie Angaben gem. § 5 ECG:</p>

      <p>
        <b>Medieninhaber und Herausgeber bzw. Diensteanbieter:</b> <br/>
        SFA Sport GmbH (FBN 518724f; HG Graz), Internetdienste, 8010 Graz, Geidorfplatz 1/10 (Herstellungsort)
      </p>

      <p>
        <b>Geschäftsführer:</b> <br/>
        DI Dr. Jochen Kerschenbauer<br>
        Christian Muckenhuber, BA<br>
      </p>
      <p>
        <b>Gesellschafter:</b> <br/>
      <ol>
        <li>
          Herr DI Dr. Kerschenbauer Jochen Edmund<br/>
          Privatperson<br/>
          Anteil: 25,10%
        </li>
        <li>
          RS digital GmbH <br>
          Anteil: 24,80%; Anteilsverhältnisse 100%
          Roland Schmid GmbH (Gesellschafter: 100% Mag. Roland Schmid)
        </li>
        <li>
          Firma Krone Media Aktiv Gesellschaft m.b.H  Anteil: 50,10%; Anteilsverhältnisse je 12,5% Helga Dichand,
          Michael Dichand, Johanna Dichand und Dr. Christoph Dichand und 50% NKZ Austria-Beteiligungs GmbH, Essen
          (Gesellschafter (indirekt): 50,5% FUNKE Österreich Holding GmbH, Essen (Anteile (direkt und indirekt): 42,25%
          Petra Grotkamp, und je 19,25% Niklas J. Wilcke, Julia A. Becker und Nora-Maria Marx) und 49,5% SIGNA Holding
          GmbH, Innsbruck (Anteile: direkt und indirekt insgesamt 77,54% Familie Benko Privatstiftung, Innsbruck
          (Stifter: René Benko und Ingeborg Benko; Begünstigte werden vom Stiftungsvorstand im Rahmen der
          Stiftungszusatzurkunde ausgewählt), 3% Ernst Tanner, Erlenbach (CH), 4,46% Fressnapf Luxembourg GmbH,
          Grevenmacher (LUX, Anteile: indirekt 100% Torsten Toeller, Krefeld, (DE)) und 15% Haselsteiner
          Familien-Privatstiftung, Spittal an der Drau (Stifter: Dkfm. Dr. Hans Peter Haselsteiner, Mag. Ulrike
          Haselsteiner, Anton Lerchbaumer, DI Sebastian Haselsteiner, Peter Klemens Haselsteiner und Johannes Anton
          Haselsteiner; Begünstigte werden vom Stiftungsvorstand im Rahmen der Stiftungserklärung ausgewählt))).
        </li>
      </ol>
      <p>
        <b>Grundlegende Richtung:</b> <br/>
        fan.at versteht sich als das Internet-Portal für alle sportinteressierten
        Österreicher und Internet-Nutzer des gesamten deutschsprachigen
        Raumes.
      <p>
        <b>Kontakt:</b> <br/>
        SFA Sport GmbH <br/>
        Geidorfplatz 1/10 <br/>
        8010 Graz <br/>
        E-Mail: <a href="mailto:info@fan.at">info@fan.at</a>
      </p>
    </div>
  </div>
</div>

